// library
import React from 'react';
// internal
// components

export default function SwapIcon({ width, height, fill, additionalStyles }) {
  const style = {
    width: `${width}px`,
    height: `${height}px`,
    ...additionalStyles,
  };
  const viewBox = `0 0 ${24} ${34}`;
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      viewBox={viewBox}
      className="swap-icon"
    >
      <g
        style={{
          transform: `translate(0px, ${2}px)`,
        }}
      >
        <path
          d="M1.15317 13.116L2.73084 11.2954C3.33772 10.5972 4.24805 10.1729 5.15839 10.1729H15.4445L14.7772 13.5108C14.5947 14.3606 15.5666 14.9675 16.2636 14.4519L24.8513 8.07959C25.367 7.7157 25.367 6.92626 24.8513 6.56237L16.2636 0.190056C15.5654 -0.325556 14.5946 0.281326 14.7772 1.13122L15.4445 4.43815H4.94598C2.27543 4.43815 0.121826 6.59308 0.121826 9.2623V12.7209C0.121826 13.2674 0.78916 13.5412 1.15305 13.1157L1.15317 13.116Z"
          fill="white"
        />
      </g>
      <g
        style={{
          transform: `translate(0px, ${height / 1.7}px)`,
        }}
      >
        <path
          d="M24.4579 1.72449C23.9115 1.51231 23.3354 1.66404 22.9407 2.11921L21.4839 3.81779C21.0596 4.30379 20.4527 4.5764 19.7842 4.5764H11.0756L11.5 2.42147C11.6517 1.7233 11.3483 1.02514 10.7414 0.631634C10.1345 0.236915 9.37587 0.267745 8.79981 0.692087L0.698164 6.73122C0.273828 7.0655 0 7.55028 0 8.09672C0 8.64316 0.242992 9.15878 0.698164 9.46222L8.79981 15.4707C9.10325 15.6829 9.46714 15.805 9.83103 15.805C10.1345 15.805 10.4688 15.7137 10.7414 15.5324C11.3483 15.1376 11.6517 14.4395 11.5 13.7425L11.0756 11.5876L19.9668 11.5864C22.9408 11.5864 25.3375 9.18968 25.3375 6.21575V2.99864C25.3683 2.42258 25.0044 1.90694 24.458 1.72442L24.4579 1.72449ZM23.729 6.24519C23.729 8.30885 22.06 9.97785 19.9963 9.97785H10.074C9.83101 9.97785 9.58801 10.0988 9.43628 10.2813C9.28456 10.4638 9.22411 10.7056 9.25374 10.9486L9.89146 14.0744C9.89146 14.1052 9.89146 14.1349 9.86064 14.1657C9.80019 14.1965 9.80019 14.1657 9.76937 14.1657L1.66894 8.15719C1.66894 8.15719 1.63812 8.12637 1.63812 8.09674C1.63812 8.06592 1.66894 8.03628 1.66894 8.03628L9.77059 2.02779C9.8014 2.02779 9.8014 1.99697 9.86186 2.02779C9.92231 2.05861 9.89267 2.08824 9.89267 2.11906L9.25496 5.24484C9.1945 5.48783 9.25496 5.73083 9.4375 5.91217C9.58922 6.09471 9.83222 6.21561 10.0752 6.21561H19.7854C20.9079 6.21561 21.97 5.72962 22.699 4.88095L23.7006 3.72762L23.6994 6.24526L23.729 6.24519Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
